import * as Sentry from '@sentry/react';
import { useQuery } from '@tanstack/react-query';
import toaster from 'react-hot-toast';
import { CentsAssistInfo, getCentsAssistInfo } from 'api/assist/getCentsAssistInfo';
import { ApiError } from 'types/api';

interface CentsAssistEndPointResponse {
  isLoading: boolean;
  error: ApiError | null;
  data: CentsAssistInfo | null;
  refetch: () => void;
}

export const useCentsAssistEndpoint = (businessId: number): CentsAssistEndPointResponse => {
  const {
    isLoading,
    error,
    data = null,
    refetch,
  } = useQuery<unknown, ApiError, CentsAssistInfo>({
    queryKey: ['getCentsAssistInfo', businessId],
    queryFn: async () => {
      const response = await getCentsAssistInfo(businessId);
      return response.data ?? {};
    },
    retry: 1,
    onError: (error) => {
      Sentry.captureException(error);

      toaster(
        error?.response?.data?.error ?? 'An error occurred while fetching Cents Assist info',
        {
          icon: '❌',
        },
      );
      return error;
    },
  });

  return {
    isLoading,
    error,
    data,
    refetch,
  };
};
